import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import BranchForm from "./BranchForm";
import DepartmentForm from "./DepartmentForm";
import JobPositionForm from "./JobPositionForm";
import CompanyLeaveForm from "./companyleaveForm";
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import ShiftForm from "./shiftForm";
import OthersForm from "./OthersForm";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

export default function Functionalities() {
  const [searchParams, setSearchParams] = useSearchParams();
  const initialTab = parseInt(searchParams.get("tabId")) || 0;
  const [value, setValue] = useState(initialTab || 0);
  const [branchOptions, setBranchOptions] = useState([]);
  const [departmentOptions, setDepartmentOptions] = useState([]);

  // Access permissions array from Redux store
  const permissions = useSelector((state) => state.emp.permissions);

  const pagePermissions = [
    "createbranchID",
    "createdepartmentID",
    "createjobpositionID",
    "addshiftsID",
    "createcompanyleaveID",
    "createothersID"
  ];

  const fetchBranches = async () => {
    try {
      const token = localStorage.getItem("accessToken");
      const response = await axios.get(
        `${process.env.REACT_APP_API}/api/employee/branches/`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setBranchOptions(response.data.map(branch => ({
        name: branch.branch_name,
        id: branch.id,
        location: branch.location
      })));
    } catch (error) {
      console.error("Error fetching branch data:", error);
    }
  };

  const fetchDepartments = async () => {
    try {
      const token = localStorage.getItem("accessToken");
      const response = await axios.get(
        `${process.env.REACT_APP_API}/api/employee/departments/`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setDepartmentOptions(response.data.map(dep => ({
        id: dep.id,
        name: dep.dep_name,
      })));
    } catch (error) {
      console.error("Error fetching department data:", error);
    }
  };

  // Define tabs after function declarations
  const tabs = [
    { label: "Branch", permission: pagePermissions[0], form: <BranchForm fetchBranches={fetchBranches} /> },
    { label: "Department", permission: pagePermissions[1], form: <DepartmentForm branchOptions={branchOptions} fetchDepartments={fetchDepartments} /> },
    { label: "Job Position", permission: pagePermissions[2], form: <JobPositionForm departmentOptions={departmentOptions} /> },
    { label: "Shift", permission: pagePermissions[3], form: <ShiftForm /> },
    { label: "Company Leave", permission: pagePermissions[4], form: <CompanyLeaveForm /> },
    { label: "Others", permission: pagePermissions[5], form: <OthersForm /> },
  ];

  // Filter tabs based on permissions
  const allowedTabs = tabs.filter((tab) => permissions.includes(tab.permission));

  // Adjust tab value if the current value is out of bounds
  useEffect(() => {
    if (allowedTabs.length > 0 && value >= allowedTabs.length) {
      setValue(0);
      setSearchParams({ tabId: 0 });
    }
  }, [value, allowedTabs, setSearchParams]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setSearchParams({ tabId: newValue }); // Update URL when tab changes
  };

  useEffect(() => {
    fetchBranches();
    fetchDepartments();
  }, []);

  return (
    <Box sx={{ width: '100%', overflowX: 'hidden', maxWidth: "900px", paddingX: '5%', paddingTop: '3%' }}>
      <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} />

      <Box sx={{ borderBottom: 1, borderColor: 'divider', maxWidth: '100%' }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="functionalities tabs"
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
        >
          {allowedTabs.map((tab, index) => (
            <Tab key={index} label={tab.label} {...a11yProps(index)} />
          ))}
        </Tabs>
      </Box>

      <Box sx={{ maxWidth: '100%', overflow: 'hidden', paddingTop: '1.8rem' }}>
        {allowedTabs.map((tab, index) => (
          <CustomTabPanel key={index} value={value} index={index}>
            {tab.form}
          </CustomTabPanel>
        ))}
      </Box>
    </Box>
  );
}